import React, { Fragment } from 'react'
import Header from './components/header/Header'
import Home from './components/home/Home'
import Menu from './components/menu/Menu'
import Office from './components/office/Office'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'

export default function App() {
  return (
    <Fragment>
      <Header/>
      <Home/>
      <Menu/>
      <Office/>
      <Contact/>
      <Footer/>
    </Fragment>
  )
}
